import type { DealerLocation } from '../types/map.types';

/** Where WorkingMap opens when the tenant has no coordinates (central Florida). */
export const DEFAULT_MAP_CENTER: [number, number] = [27.9944024, -81.7602544];
export const DEFAULT_MAP_ZOOM = 7;

// Roughly what zoom 7 shows on a desktop-sized map; generous on purpose, since the
// map replaces these bounds with its real ones as soon as it reports them.
const FALLBACK_LAT_HALF_SPAN = 2.5;
const FALLBACK_LNG_HALF_SPAN = 4;

export interface MapBoundsBox {
  north: number;
  south: number;
  east: number;
  west: number;
}

/** Bounds around a center, used before the map has reported its own. */
export function boundsAroundCenter(
  [lat, lng]: [number, number],
  latHalfSpan = FALLBACK_LAT_HALF_SPAN,
  lngHalfSpan = FALLBACK_LNG_HALF_SPAN
): MapBoundsBox {
  return {
    north: lat + latHalfSpan,
    south: lat - latHalfSpan,
    east: lng + lngHalfSpan,
    west: lng - lngHalfSpan
  };
}

/**
 * Everything a dealer marker renders from, so the map re-renders exactly when a marker
 * would change. Assignment rings are tracked separately through `summaryVersion`.
 */
export function dealerLocationsSignature(dealers: DealerLocation[]): string {
  return dealers
    .map(d =>
      [
        d.dealerId,
        d.coordinates.latitude,
        d.coordinates.longitude,
        d.recallCount,
        d.vehicleCount,
        d.highestSkillLevel ?? '',
        d.name ?? '',
        d.address
      ].join(':')
    )
    .join('|');
}
